import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { DataAmigavel } from '@/shared/utils/datas';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { EnumerateDefensores } from '@/modules/people/defensor.service';
import { GetDiretoria, SetDiretoria, DeleteDiretoria, GetDiretoriaLotacoes, SetDiretoriaLotacao, DeleteDiretoriaLotacao } from '@/modules/structure/diretoria/diretoria.service';
import { diretoriaFormSchema, diretoriaLotacaoFormSchema } from '@/modules/structure/diretoria/diretoria.schema';
import { FieldError, formControlClass, formSelectClass } from '@/shared/components/forms/FormFieldFeedback';
import { zodResolver } from '@hookform/resolvers/zod';
import { useNavigate, useParams } from 'react-router-dom';
import { Modal, Button, Form, Col, Row } from 'react-bootstrap';
import { ReadDiretoriaDto, ReadDiretoriaLotacaoDto, CreateDiretoriaLotacaoDto } from '@/api.types';
import { SubmitHandler, useForm, type Resolver } from 'react-hook-form';
import { Tabelas } from '@/shared/constants/tables';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';

interface IOpcao { value: number; label: string; }
type DiretoriaLotacaoFormDto = CreateDiretoriaLotacaoDto & { diretor?: boolean };

export default function DiretoriaEditPage() {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm<ReadDiretoriaDto>({
    resolver: zodResolver(diretoriaFormSchema) as unknown as Resolver<ReadDiretoriaDto>,
    mode: 'onTouched',
  });
  const { setActions } = useBreadcrumbActions();
  const navigate = useNavigate();
  const params = useParams();

  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalLotacaoShow, setModalLotacaoShow] = useState(false);
  const [lotacaoIndex, setLotacaoIndex] = useState(-1);
  const [lotacoes, setLotacoes] = useState<ReadDiretoriaLotacaoDto[]>([]);
  const [defensores, setDefensores] = useState<IOpcao[]>([]);
  const [lotacaoParaExcluir, setLotacaoParaExcluir] = useState<number | null>(null);

  const id = params.id ? Number(params.id) : 0;
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  const onInvalid = () => {
    toast.error('Corrija os campos destacados antes de salvar.');
  };

  const onInvalidLotacao = () => {
    toast.error('Corrija os campos destacados antes de salvar.');
  };

  const [loaded, setLoaded] = useState<boolean>(false);

  const {
    register: registerLotacao,
    handleSubmit: handleSubmitLotacao,
    reset: resetLotacao,
    formState: { errors: errorsLotacao },
  } = useForm<DiretoriaLotacaoFormDto>({
    resolver: zodResolver(diretoriaLotacaoFormSchema) as unknown as Resolver<DiretoriaLotacaoFormDto>,
    mode: 'onTouched',
  });

  useEffect(() => {
    setActions({
      secondary: { label: 'Novo', href: Links.Diretoria_Criar, onClick: () => { } },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions]);

  async function buscar() {
    if (id > 0) {
      await GetDiretoria(id)
        .then((result) => {
          reset(result);
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });

      await GetDiretoriaLotacoes(id)
        .then((result) => {
          setLotacoes(result);
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
    }
  }

  useEffect(() => {
    Promise.all([
      EnumerateDefensores(0, 1000, false, true, 'nome', true, '', '').then((result) => {
        setDefensores(
          result.objects.map((item) => {
            return { value: item.id, label: item.pessoa!.nome };
          }),
        );
      }),
      buscar(),
    ])
      .then(() => setLoaded(true))
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, []);

  const onSubmit: SubmitHandler<ReadDiretoriaDto> = (data) => {
    setIsLoading(true);
    const dados: ReadDiretoriaDto = {
      id: id,
      nome: data.nome,
    } as ReadDiretoriaDto;

    SetDiretoria(dados)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.Diretoria_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      })
      .finally(() => setIsLoading(false));
  };

  const handleExcluirDiretoria = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setModalExcluirShow(false);
    DeleteDiretoria(id)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.Diretoria_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  };

  const onSubmitLotacao: SubmitHandler<DiretoriaLotacaoFormDto> = (data) => {
    if (!id || id <= 0) {
      toast.warning('Salve a diretoria antes de adicionar lotações.');
      return;
    }

    const lotacaoData: CreateDiretoriaLotacaoDto = {
      id: lotacaoIndex >= 0 && lotacoes[lotacaoIndex]?.id ? lotacoes[lotacaoIndex].id : undefined,
      diretoria: { id: id },
      defensor: { id: Number(data.defensor.id) },
      inicio: data.inicio,
      fim: data.fim || undefined,
      diretor: Boolean(data.diretor),
    };

    SetDiretoriaLotacao(lotacaoData)
      .then((res) => {
        toast.success(res + '');
        setModalLotacaoShow(false);
        resetLotacao();
        setLotacaoIndex(-1);
        buscar();
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  };

  const handleEditarLotacao = (index: number) => {
    const lotacao = lotacoes[index];
    setLotacaoIndex(index);
    resetLotacao({
      defensor: { id: lotacao.defensor.id },
      inicio: lotacao.inicio ? new Date(lotacao.inicio).toISOString().split('T')[0] : '',
      fim: lotacao.fim ? new Date(lotacao.fim).toISOString().split('T')[0] : '',
      diretor: Boolean((lotacao as ReadDiretoriaLotacaoDto & { diretor?: boolean }).diretor),
    });
    setModalLotacaoShow(true);
  };

  const handleExcluirLotacao = () => {
    if (lotacaoParaExcluir !== null) {
      DeleteDiretoriaLotacao(lotacaoParaExcluir)
        .then((res) => {
          toast.success(res + '');
          setLotacaoParaExcluir(null);
          buscar();
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
    }
  };

  const abrirModalAdicionarLotacao = () => {
    setLotacaoIndex(-1);
    resetLotacao();
    setModalLotacaoShow(true);
  };

  if (!loaded) return <Loading />;

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3>Diretoria</h3>
        </div>
      </div>
      <hr className="pb-4" />

      <form
        onSubmit={(event) => {
          void handleSubmit(onSubmit, onInvalid)(event);
        }}
      >
        <div className="row">
          <div className="mb-3 col-md-12">
            <label htmlFor="nome" className="form-label">
              Nome da Diretoria: <span className="text-danger">*</span>
            </label>
            <input
              title="nome"
              type="text"
              className={formControlClass(!!errors.nome)}
              {...register('nome')}
            />
            <FieldError message={errors.nome?.message} />
          </div>
        </div>

        {id > 0 && (
          <div className="card mb-3">
            <div className="card-header">
              <h5>Lotações</h5>
              <div className="float-end">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={abrirModalAdicionarLotacao}
                  title="Adicionar nova lotação"
                >
                  Adicionar Lotação
                </button>
              </div>
            </div>
            <div className="card-body">
              <table className="table table-sm table-bordered table-hover table-striped text-center">
                <thead>
                  <tr>
                    <th>Defensor</th>
                    <th>Início</th>
                    <th>Fim</th>
                    <th>Diretor</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {lotacoes.map((lotacao, index) => (
                    <tr key={lotacao.id}>
                      <td>{lotacao.defensor.pessoa?.nome}</td>
                      <td>{DataAmigavel(lotacao.inicio)}</td>
                      <td>{lotacao.fim ? DataAmigavel(lotacao.fim) : '-'}</td>
                      <td>{(lotacao as ReadDiretoriaLotacaoDto & { diretor?: boolean }).diretor ? 'Sim' : ''}</td>
                      <td>
                        <button type="button" className="btn btn-sm btn-outline-dark me-2 mb-2" onClick={() => handleEditarLotacao(index)} >
                          Editar
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm mb-2"
                          title="Remover essa lotação."
                          onClick={() => {
                            setLotacaoParaExcluir(lotacao.id);
                            setModalExcluirShow(true);
                          }}
                        >
                          Excluir
                        </button>
                      </td>
                    </tr>
                  ))}
                  {lotacoes.length === 0 && (
                    <tr>
                      <td colSpan={4} className="text-center">
                        Nenhuma lotação cadastrada.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {id > 0 && (
          <EditadoPorRodape dados={{ editadoPor: watch('editadoPor'), editadoEm: watch('editadoEm') }} />
        )}

        <div>
          <BotoesSalvarExcluir
            isLoading={isLoading}
            texto={btnSalvar}
            textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
            id={id}
            onExcluirClick={() => setModalExcluirShow(true)}
          />
        </div>

      </form>

      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.diretoria}
        idRegistro={id}
      />

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={lotacaoParaExcluir !== null ? handleExcluirLotacao : handleExcluirDiretoria}
        handleHide={() => {
          setModalExcluirShow(false);
          setLotacaoParaExcluir(null);
        }}
      />

      <Modal show={modalLotacaoShow} onHide={() => setModalLotacaoShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {lotacaoIndex >= 0 ? 'Editar ' : 'Adicionar '} Lotação
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(event) => {
              void handleSubmitLotacao(onSubmitLotacao, onInvalidLotacao)(event);
            }}
          >
            <Row className="mb-3">
              <Form.Group as={Col} md="12" className="mb-3">
                <label htmlFor="defensor" className="form-label">
                  Defensor: <span className="text-danger">*</span>
                </label>
                <select
                  id="defensor"
                  className={formSelectClass(!!errorsLotacao.defensor?.id)}
                  {...registerLotacao('defensor.id')}
                >
                  <option value="">Selecione um defensor</option>
                  {defensores.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
                <FieldError message={errorsLotacao.defensor?.id?.message} />
              </Form.Group>
              <Form.Group as={Col} md="6" className="mb-3">
                <label htmlFor="inicio" className="form-label">
                  Início: <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  id="inicio"
                  className={formControlClass(!!errorsLotacao.inicio)}
                  {...registerLotacao('inicio')}
                />
                <FieldError message={errorsLotacao.inicio?.message} />
              </Form.Group>
              <Form.Group as={Col} md="6" className="mb-3">
                <label htmlFor="fim" className="form-label">
                  Fim:
                </label>
                <input
                  type="date"
                  id="fim"
                  className="form-control"
                  {...registerLotacao('fim')}
                />
              </Form.Group>
              <Form.Group as={Col} md="12" className="mb-3">
                <div className="form-check">
                  <input
                    type="checkbox"
                    id="diretor"
                    className="form-check-input"
                    {...registerLotacao('diretor')}
                  />
                  <label className="form-check-label" htmlFor="diretor">
                    Diretor(a) desta diretoria regional
                  </label>
                </div>
              </Form.Group>
            </Row>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setModalLotacaoShow(false)}>
                Fechar
              </Button>
              <Button type="submit" variant="success">
                Salvar
              </Button>
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

